function OnDocumentReady (){
		   
	   Seatics.addTicketData(tickets);
	   Seatics.config.alwaysShowAvailQty = true;
	   Seatics.config.preCheckoutButtonHtml = 'Buy tickets';
	   Seatics.config.defaultSort = Seatics.SortOptions.Marked;  //options: PriceAsc, PriceDesc, SectionAsc, SectionDesc, Marked
	   Seatics.config.saveFilterOptions = true;
	   Seatics.config.ticketListOnRight = true;
	   Seatics.config.legendExpanded = false;
	   Seatics.config.showCents = true;
	   Seatics.config.desktopEventInfoRightCol = "";
	   Seatics.config.tgMarkHtml = "<span class='Preferred' title='Preferred'></span>";

	   Seatics.config.mapFinishedRenderingHandler = function () {
		   $(".event-info-place").wrap(locationLink);
		   $(".event-info-date").wrap(googleCalendarLink);
		   $("#event-info-area").css("z-index", 999);
		   
		   if (web_curr == 1) 
				$(".venue-ticket-list-cta-amt").each(function () {
					$(this).text($(this).text().replace("US$", "CAD"));
				});
		   
		   if ($(window).width() <= 767) {
				$("#top-search").hide();
				$(".col-lg-12").css("padding", "0");
				$(".col-lg-12").css("");

				$("#main-footer").hide();
				$("#feedback-form").hide();
				$("#navbar").hide();
				$("#wrapper").css("overflow-y", "hidden");
				$("#wrapper").css("height", 0);
		   }
		   
		   var targetNode1 = document.getElementById('precheckout-parent');
		   var targetNode2 = document.getElementById('pre-checkout-price-amt');
		   
		   var observer1 = new MutationObserver(function(){
		      if(targetNode1.style.display !='none' && web_curr == 1) 
					$("#pre-checkout-est-section-calc").text ($("#pre-checkout-est-section-calc").text ().replace("US$", "CAD"));
		   });

		   var observer2 = new MutationObserver(function(mutations, observer){
			      if (web_curr == 1) {
			    	  observer.disconnect();
					  $("#pre-checkout-price-amt").text($("#pre-checkout-price-amt").text().replace("US$", "CAD"));
					  observer.observe(targetNode2, { attributes: true, childList: true });
			      }		
			   });
		   
		   observer1.observe(targetNode1, { attributes: true, childList: true });
		   observer2.observe(targetNode2, { attributes: true, childList: true });
	   };

	   Seatics.Presentation.redirectToCheckout = function(ticketGroup, quantitySelected) {
		    if (quantitySelected == null || quantitySelected == 0)
		    	alert("Please select how many tickets you wish to buy");
		    else
		    	add_to_basket (eventID, ticketGroup.tgID, parseInt(quantitySelected));
	   }
	   
	   Seatics.config.ticketRowRenderedHandler = function () {
		   if(web_curr == 1) 
			   $(".venue-ticket-list-cta-amt").each(function () {
				   $(this).text($(this).text().replace("US$", "CAD"));
			   });
	   }
}